export enum MutationKeys {
  feedGeneration = 'feedGeneration',
}
